package fr.frux.shared.data.mapper

import fr.frux.core.maps.Location
import fr.frux.shared.domain.model.Place
import fr.frux.shared.domain.model.PlaceType
import fr.frux.shared.dto.PlaceDto
import fr.frux.shared.dto.PlaceKind

fun PlaceDto.toDomain(): Place =
    Place(
        label = label,
        detail = detail,
        type =
            when (kind) {
                PlaceKind.MUNICIPALITY -> PlaceType.MUNICIPALITY
                PlaceKind.STREET -> PlaceType.STREET
                PlaceKind.ADDRESS -> PlaceType.ADDRESS
                PlaceKind.LOCALITY -> PlaceType.LOCALITY
                PlaceKind.POI -> PlaceType.POI
            },
        location = Location(latitude, longitude),
    )
